RegistrationEmailCtrl = ($scope, $filter, $translate, $location, flash, RegistrationService, AuthService, TermService) ->
  return $location.path('/') if AuthService.isSignedIn()
  # return $location.path('/term') unless TermService.isAccepted()

  $scope.isSubmitting = false
  RegistrationService.clearAcceptLocal()
  $scope.email = ''
  
  $scope.submit = (email) ->
    $scope.isSubmitting = true
    RegistrationService.create_email(email).then (resp) ->
      RegistrationService.setTokenFormEmail(data.email)
      $location.path("/registration/email/success")
    .catch (resp) ->
      if resp.data?.code is 'E0101'
        flash.error $filter('translate')('EMAIL_DUPLICATED')
      else
        flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isSubmitting = false

RegistrationEmailCtrl.$inject = [
  '$scope'
  '$filter'
  '$translate'
  '$location'
  'flash'
  'RegistrationService'
  'AuthService'
  'TermService'
]

module.exports = RegistrationEmailCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/email-controller.coffee